import { connect } from 'react-redux'
import {
  selectAgentViewTicketStatusesForCurrentTicket,
  selectAgentReplyToTicketStatusesForCurrentTicket,
  selectAgentTypeOnTicketStatusesForCurrentTicket,
  selectAgentAddNoteStatusesForCurrentTicket,
} from 'selectors/agents_collision'
import AgentCollision from './view'

const select = state => ({
  typingAgents: selectAgentTypeOnTicketStatusesForCurrentTicket(state),
  noteLeavingAgents: selectAgentAddNoteStatusesForCurrentTicket(state),
  replyingAgents: selectAgentReplyToTicketStatusesForCurrentTicket(state),
  viewingAgents: selectAgentViewTicketStatusesForCurrentTicket(state),
})

export default connect(select, null)(AgentCollision)
